<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "d-flex justify-content-start align-items-center mb-1",
          },
          [_c("h3", [_vm._v(_vm._s(_vm.$t("payment.Payment-Method")))])]
        ),
        _c("div", { staticClass: "add-pay-method" }, [
          _c("div", { staticClass: "pay-m-desc" }, [
            _c("div", { staticClass: "payment-desc" }, [
              _vm._v(" " + _vm._s(_vm.$t("payment.pay-desc-1")) + " "),
            ]),
            _c("div", { staticClass: "payment-desc" }, [
              _vm._v(" " + _vm._s(_vm.$t("payment.pay-desc-2")) + " "),
            ]),
          ]),
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.showAddPayment()
                    },
                  },
                },
                [
                  _c("feather-icon", { attrs: { icon: "PlusIcon" } }),
                  _vm._v(" " + _vm._s(_vm.$t("payment.add-new-payment")) + " "),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "filter-box" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "3" } },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("SelectPaymentMethod", {
                          attrs: {
                            multiple: false,
                            isEditFlag: _vm.isEditFlag,
                            placeholder: _vm.$t("payment.PaymentMethod"),
                          },
                          model: {
                            value: _vm.selectedPaymentMethod,
                            callback: function ($$v) {
                              _vm.selectedPaymentMethod = $$v
                            },
                            expression: "selectedPaymentMethod",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { cols: "3" } },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("b-form-input", {
                          attrs: { placeholder: _vm.$t("payment.Search") },
                          model: {
                            value: _vm.searchText,
                            callback: function ($$v) {
                              _vm.searchText = $$v
                            },
                            expression: "searchText",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "payment-page" },
          [
            _c("b-table", {
              attrs: { items: _vm.items, fields: _vm.fields, responsive: "" },
              scopedSlots: _vm._u([
                {
                  key: "cell(paymentMethodName)",
                  fn: function (data) {
                    return [
                      _c("div", { staticClass: "pay-method-row" }, [
                        _c("div", {
                          staticClass: "pay-color-line",
                          style: {
                            backgroundColor:
                              data.item.config && data.item.config.uiColour
                                ? data.item.config.uiColour
                                : "#00db00",
                          },
                        }),
                        _vm._v(" " + _vm._s(data.value) + " "),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(accountName)",
                  fn: function (data) {
                    return [_vm._v(" " + _vm._s(data.value) + " ")]
                  },
                },
                {
                  key: "cell(accountId)",
                  fn: function (data) {
                    return [_vm._v(" " + _vm._s(data.value) + " ")]
                  },
                },
                {
                  key: "cell(action)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        { staticClass: "action-btn" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.v-primary",
                                  modifiers: { hover: true, "v-primary": true },
                                },
                              ],
                              staticClass: "btn-icon",
                              attrs: {
                                variant: "flat-primary",
                                title: _vm.$t("payment.Edit"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.editPaymentMethod(data.item, true)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "EditIcon" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.v-primary",
                                  modifiers: { hover: true, "v-primary": true },
                                },
                              ],
                              staticClass: "btn-icon",
                              attrs: {
                                variant: "flat-danger",
                                title: _vm.$t("payment.Delete"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showDeletePayment(data.item)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "Trash2Icon" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-center justify-content-sm-end",
                    attrs: { cols: "12", sm: "12" },
                  },
                  [
                    _vm.isPaginationVisible
                      ? _c("b-pagination", {
                          key: _vm.page,
                          staticClass: "mb-0 mt-1 mt-sm-0",
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.size,
                            "first-number": "",
                            "last-number": "",
                            "prev-class": "prev-item",
                            "next-class": "next-item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "prev-text",
                                fn: function () {
                                  return [
                                    _c("feather-icon", {
                                      attrs: {
                                        icon: "ChevronLeftIcon",
                                        size: "18",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "next-text",
                                fn: function () {
                                  return [
                                    _c("feather-icon", {
                                      attrs: {
                                        icon: "ChevronRightIcon",
                                        size: "18",
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1308952388
                          ),
                          model: {
                            value: _vm.page,
                            callback: function ($$v) {
                              _vm.page = $$v
                            },
                            expression: "page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("EditPaymentMethod", {
        attrs: {
          hideEditPayment: _vm.hideEditPayment,
          EditPayment: _vm.EditPayment,
          showData: _vm.showData,
          paymentMethodText: _vm.paymentMethodText,
          editPaymentMethod: _vm.editPaymentMethod,
        },
      }),
      _c("AddPaymentMethod", {
        attrs: {
          AddPayment: _vm.AddPayment,
          closePaymentPop: _vm.closePaymentPop,
          showData: _vm.showData,
          paymentMethodText: _vm.paymentMethodText,
          isEditFlag: _vm.isEditFlag,
          id: _vm.id,
          accountQrcodeUrl: _vm.accountQrcodeUrl,
        },
      }),
      _c("DeletePopup", {
        attrs: {
          isDeletePaymentPop: _vm.isDeletePaymentPop,
          id: _vm.id,
          closePaymentPop: _vm.closePaymentPop,
          deleteApi: _vm.deletePaymentMethod,
        },
      }),
      _c("KycNotComplete", {
        attrs: {
          showPop: _vm.warningPop,
          onModalHidden: _vm.onModalHidden,
          msg: _vm.warningMsg,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/payment/Payment.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import assets_rashi_coin_QRcode_svg from '@/assets/rashi-coin/QRcode.svg';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import views_payment_EditPaymentMethod_vue from '@/views/payment/EditPaymentMethod.vue';
import layouts_components_AddPaymentMethod_vue from '@/layouts/components/AddPaymentMethod.vue';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuex from 'vuex';
import layouts_components_SelectPaymentMethod_vue from '@/layouts/components/SelectPaymentMethod.vue';
import layouts_components_DeletePopup_vue from '@/layouts/components/DeletePopup.vue';
import layouts_components_KycNotComplete_vue from '@/layouts/components/KycNotComplete.vue';
import utils_constants from '@/utils/constants';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    QRcode: assets_rashi_coin_QRcode_svg,
    copy: assets_rashi_coin_copy_svg,
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BContainer: bootstrapvue["BContainer"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BAvatar: bootstrapvue["BAvatar"],
    BBadge: bootstrapvue["BBadge"],
    vSelect: vue_select,
    BFormInput: bootstrapvue["BFormInput"],
    BDropdown: bootstrapvue["BDropdown"],
    BInputGroup: bootstrapvue["BInputGroup"],
    BInputGroupText: bootstrapvue["BInputGroupText"],
    BDropdownItem: bootstrapvue["BDropdownItem"],
    BInputGroupPrepend: bootstrapvue["BInputGroupPrepend"],
    BInputGroupAppend: bootstrapvue["BInputGroupAppend"],
    AddPaymentMethod: layouts_components_AddPaymentMethod_vue,
    EditPaymentMethod: views_payment_EditPaymentMethod_vue,
    BPagination: bootstrapvue["BPagination"],
    SelectPaymentMethod: layouts_components_SelectPaymentMethod_vue,
    DeletePopup: layouts_components_DeletePopup_vue,
    KycNotComplete: layouts_components_KycNotComplete_vue
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  data() {
    return {
      AddPayment: false,
      EditPayment: false,
      fields: [{
        key: "paymentMethodName",
        label: this.$t("payment.PaymentMethod"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "accountName",
        label: this.$t("payment.AccountName"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "accountId",
        label: this.$t("payment.AccountDetails"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "action",
        label: this.$t("payment.Action"),
        tdClass: "action-pay n-wrap",
        thClass: "action-pay n-wrap"
      }],
      searchText: "",
      items: [],
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isLoading: false,
      isPaginationVisible: false,
      totalRows: 0,
      showData: [],
      paymentMethodText: "",
      isEditFlag: false,
      id: "",
      accountQrcodeUrl: "",
      selectedPaymentMethod: "",
      isDeletePaymentPop: false,
      warningPop: false,
      warningMsg: "",
      firstTime: true
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData", "user"])
  },
  mounted() {
    let flag = 0;
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.page = this.$route.query.page;
      flag++;
    }
    if (this.$route && this.$route.query && this.$route.query.searchText && this.searchText !== this.$route.query.searchText) {
      this.searchText = this.$route.query.searchText;
    }
    if (this.$route && this.$route.query && this.$route.query.selectedPaymentMethod && this.selectedPaymentMethod !== this.$route.query.selectedPaymentMethod) {
      this.selectedPaymentMethod = this.$route.query.selectedPaymentMethod;
    }
    if (!flag) {
      this.getAllPayment();
    }
    setTimeout(() => {
      this.firstTime = false;
    }, 5 * 1000);
  },
  watch: {
    size() {
      if (!this.size) {
        this.size = 10;
      }
      this.getAllPayment();
    },
    page() {
      utils_constants["setPagination"].apply(this, [`${this.page}`]);
      this.getAllPayment();
    },
    searchText(newVal) {
      let obj = {
        searchText: newVal
      };
      utils_constants["setQueryParams"].apply(this, [obj]);
      this.search();
    },
    selectedPaymentMethod(newVal, oldVal) {
      let obj = {
        selectedPaymentMethod: newVal
      };
      utils_constants["setQueryParams"].apply(this, [obj]);
      this.search();
    }
  },
  methods: {
    search() {
      const debounceTime = 500;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        if (this.firstTime || this.page == 1) {
          this.getAllPayment();
        }
        if (!this.firstTime) {
          this.page = 1;
        }
      }, debounceTime);
    },
    paymentMethod(methodName, data) {
      if (this.refData && this.refData.countryData && this.refData.countryData.paymentMethods && this.refData.countryData.paymentMethods.length) {
        const foundObject = this.refData.countryData.paymentMethods.find(obj => obj.id === methodName);
        this.mapFields(foundObject.fields, data);
      }
    },
    mapFields(fields, data) {
      let paymentFields = fields.map(field => {
        const rules = {};
        if (field.isRequired) {
          rules.required = true;
        }
        if (field.maxSize) {
          rules.max = parseInt(field.maxSize);
        }
        if (field.minSize) {
          rules.min = parseInt(field.minSize);
        }
        if (field.regex) {
          rules.regex = new RegExp(field.regex);
        }
        if (field.type && field.type === "string") {
          field.type = "text";
        }
        return {
          ...field,
          value: data[field.id],
          rules
        };
      }) || [];
      this.showData = paymentFields;
      this.paymentMethodText = data.paymentMethod;
      this.id = data.id;
      this.accountQrcodeUrl = data.accountQrcodeUrl;
    },
    closePaymentPop(flag) {
      this.AddPayment = false;
      this.isDeletePaymentPop = false;
      this.showData = [];
      this.clearAllData();
      if (flag) {
        if (this.page === 1) {
          this.getAllPayment();
        }
        this.page = 1;
      }
    },
    showEditPayment(props) {
      this.paymentMethod(props.paymentMethod, props);
      this.EditPayment = true;
    },
    showDeletePayment(props) {
      this.id = props.id;
      // this.paymentMethod(props.paymentMethod, props);
      this.isDeletePaymentPop = true;
    },
    hideEditPayment() {
      this.EditPayment = false;
      if (!this.isEditFlag) {
        this.clearAllData();
      }
    },
    clearAllData() {
      this.isEditFlag = false;
      this.showData = [];
      this.paymentMethodText = "";
      this.id = "";
      this.accountQrcodeUrl = "";
    },
    onModalHidden(props) {
      this.warningPop = props;
    },
    showAddPayment(props) {
      if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
        this.onModalHidden(true);
        this.warningMsg = this.$t("Kyc.kycNotCompleteForPayment", {
          add: props ? "edit" : "add"
        });
        return;
      }
      if (props) {
        this.isEditFlag = true;
      } else {
        this.isEditFlag = false;
      }
      this.AddPayment = true;
    },
    hideAddPayment() {
      this.isEditFlag = false;
      this.AddPayment = false;
    },
    showHideDeletePaymentPop(flag) {
      this.isDeletePaymentPop = flag;
    },
    editPaymentMethod(props, mapFlag) {
      if (mapFlag) {
        this.paymentMethod(props.paymentMethod, props);
      } else {
        this.showData = props;
      }
      this.isEditFlag = true;
      this.showAddPayment(props);
      this.hideEditPayment();
    },
    addFilter(filter) {
      if (filter && this.verificationStatus != filter) {
        this.verificationStatus = filter;
      } else {
        this.verificationStatus = "";
      }
      if (this.page === 1) {
        this.getAllPayment();
      }
      this.page = 1;
    },
    async getAllPayment() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/payment/all`
        }, {
          searchText: this.searchText || undefined,
          paymentMethod: !this.selectedPaymentMethod || this.selectedPaymentMethod === "ALL" ? undefined : this.selectedPaymentMethod,
          page: this.page,
          size: this.size,
          orderByCreatedTime: "desc"
        }, {
          isLoading: true
        });
        if (res && res.userPaymentMethodList) {
          this.items = res.userPaymentMethodList;
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async deletePaymentMethod(id) {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "DELETE",
          url: `p2p/payment/delete/${id}`
        }, {}, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.showHideDeletePaymentPop(false);
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: this.$t("feedbback.PaymentMethodDeletedSuccessfully"),
              icon: "EditIcon",
              variant: "success"
            }
          });
          this.getAllPayment();
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/views/payment/Payment.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.v-select {
  position: relative;
  font-family: inherit;
}
.v-select,
.v-select * {
  box-sizing: border-box;
}

/* KeyFrames */
@-webkit-keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@-webkit-keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
@keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
/* Dropdown Default Transition */
.vs__fade-enter-active,
.vs__fade-leave-active {
  pointer-events: none;
  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}
.vs__fade-enter,
.vs__fade-leave-to {
  opacity: 0;
}

/** Component States */
/*
 * Disabled
 *
 * When the component is disabled, all interaction
 * should be prevented. Here we modify the bg color,
 * and change the cursor displayed on the interactive
 * components.
 */
[dir] .vs--disabled .vs__dropdown-toggle, [dir] .vs--disabled .vs__clear, [dir] .vs--disabled .vs__search, [dir] .vs--disabled .vs__selected, [dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #f8f8f8;
}

/*
 *  RTL - Right to Left Support
 *
 *  Because we're using a flexbox layout, the `dir="rtl"`
 *  HTML attribute does most of the work for us by
 *  rearranging the child elements visually.
 */
.v-select[dir=rtl] .vs__actions {
  padding: 0 3px 0 6px;
}
.v-select[dir=rtl] .vs__clear {
  margin-left: 6px;
  margin-right: 0;
}
.v-select[dir=rtl] .vs__deselect {
  margin-left: 0;
  margin-right: 2px;
}
.v-select[dir=rtl] .vs__dropdown-menu {
  text-align: right;
}

/**
    Dropdown Toggle

    The dropdown toggle is the primary wrapper of the component. It
    has two direct descendants: .vs__selected-options, and .vs__actions.

    .vs__selected-options holds the .vs__selected's as well as the
    main search input.

    .vs__actions holds the clear button and dropdown toggle.
 */
.vs__dropdown-toggle {
  appearance: none;
  display: flex;
  white-space: normal;
}
[dir] .vs__dropdown-toggle {
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
}
[dir] .vs__selected-options {
  padding: 0 2px;
}
.vs__actions {
  display: flex;
  align-items: center;
}
[dir=ltr] .vs__actions {
  padding: 4px 6px 0 3px;
}
[dir=rtl] .vs__actions {
  padding: 4px 3px 0 6px;
}

/* Dropdown Toggle States */
[dir] .vs--searchable .vs__dropdown-toggle {
  cursor: text;
}
[dir] .vs--unsearchable .vs__dropdown-toggle {
  cursor: pointer;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-bottom-color: transparent;
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir] .vs__open-indicator {
  transform: scale(1);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir=ltr] .vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(1);
}
[dir=rtl] .vs--open .vs__open-indicator {
  transform: rotate(-180deg) scale(1);
}
.vs--loading .vs__open-indicator {
  opacity: 0;
}

/* Clear Button */
.vs__clear {
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__clear {
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
[dir=ltr] .vs__clear {
  margin-right: 8px;
}
[dir=rtl] .vs__clear {
  margin-left: 8px;
}

/* Dropdown Menu */
.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  z-index: 1000;
  width: 100%;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  list-style: none;
}
[dir] .vs__dropdown-menu {
  padding: 5px 0;
  margin: 0;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #d8d6de;
  border-top-style: none;
  border-radius: 0 0 0.357rem 0.357rem;
  background: #fff;
}
[dir=ltr] .vs__dropdown-menu {
  left: 0;
  text-align: left;
}
[dir=rtl] .vs__dropdown-menu {
  right: 0;
  text-align: right;
}
[dir] .vs__no-options {
  text-align: center;
}

/* List Items */
.vs__dropdown-option {
  line-height: 1.42857143;
  /* Normalize line height */
  display: block;
  color: #333;
  /* Overrides most CSS frameworks */
  white-space: nowrap;
}
[dir] .vs__dropdown-option {
  padding: 3px 20px;
  clear: both;
}
[dir] .vs__dropdown-option:hover {
  cursor: pointer;
}
.vs__dropdown-option--highlight {
  color: #8dc540 !important;
}
[dir] .vs__dropdown-option--highlight {
  background: rgba(141, 197, 64, 0.12);
}
.vs__dropdown-option--disabled {
  color: rgba(60, 60, 60, 0.5);
}
[dir] .vs__dropdown-option--disabled {
  background: inherit;
}
[dir] .vs__dropdown-option--disabled:hover {
  cursor: inherit;
}

/* Selected Tags */
.vs__selected {
  display: flex;
  align-items: center;
  color: #333;
  line-height: 1.8;
  z-index: 0;
}
[dir] .vs__selected {
  background-color: #8dc540;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}
.vs__deselect {
  display: inline-flex;
  appearance: none;
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__deselect {
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
  text-shadow: 0 1px 0 #fff;
}
[dir=ltr] .vs__deselect {
  margin-left: 4px;
}
[dir=rtl] .vs__deselect {
  margin-right: 4px;
}

/* States */
[dir] .vs--single .vs__selected {
  background-color: transparent;
  border-color: transparent;
}
.vs--single.vs--open .vs__selected {
  position: absolute;
  opacity: 0.4;
}
.vs--single.vs--searching .vs__selected {
  display: none;
}

/* Search Input */
/**
 * Super weird bug... If this declaration is grouped
 * below, the cancel button will still appear in chrome.
 * If it's up here on it's own, it'll hide it.
 */
.vs__search::-webkit-search-cancel-button {
  display: none;
}
.vs__search::-webkit-search-decoration,
.vs__search::-webkit-search-results-button,
.vs__search::-webkit-search-results-decoration,
.vs__search::-ms-clear {
  display: none;
}
.vs__search,
.vs__search:focus {
  appearance: none;
  line-height: 1.8;
  font-size: 1em;
  outline: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1;
}
[dir] .vs__search, [dir] .vs__search:focus {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
}
[dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
  border-left: none;
}
[dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
  border-right: none;
}
.vs__search::placeholder {
  color: #6e6b7b;
}

/**
    States
 */
.vs--unsearchable .vs__search {
  opacity: 1;
}
[dir] .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
  cursor: pointer;
}
.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: 0.2;
}

/* Loading Spinner */
.vs__spinner {
  align-self: center;
  opacity: 0;
  font-size: 5px;
  text-indent: -9999em;
  overflow: hidden;
  transition: opacity 0.1s;
}
[dir] .vs__spinner {
  border-top: 0.9em solid rgba(100, 100, 100, 0.1);
  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
  transform: translateZ(0);
}
[dir=ltr] .vs__spinner {
  border-right: 0.9em solid rgba(100, 100, 100, 0.1);
  border-left: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-ltr 1.1s infinite linear;
}
[dir=rtl] .vs__spinner {
  border-left: 0.9em solid rgba(100, 100, 100, 0.1);
  border-right: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-rtl 1.1s infinite linear;
}
.vs__spinner,
.vs__spinner:after {
  width: 5em;
  height: 5em;
}
[dir] .vs__spinner, [dir] .vs__spinner:after {
  border-radius: 50%;
}

/* Loading Spinner States */
.vs--loading .vs__spinner {
  opacity: 1;
}
.vs__open-indicator {
  fill: none;
}
[dir] .vs__open-indicator {
  margin-top: 0.15rem;
}
.vs__dropdown-toggle {
  transition: all 0.25s ease-in-out;
}
[dir] .vs__dropdown-toggle {
  padding: 0.59px 0 4px 0;
}
[dir=ltr] .vs--single .vs__dropdown-toggle {
  padding-left: 6px;
}
[dir=rtl] .vs--single .vs__dropdown-toggle {
  padding-right: 6px;
}
.vs__dropdown-option--disabled {
  opacity: 0.5;
}
[dir] .vs__dropdown-option--disabled.vs__dropdown-option--selected {
  background: #8dc540 !important;
}
.vs__dropdown-option {
  color: #6e6b7b;
}
[dir] .vs__dropdown-option, [dir] .vs__no-options {
  padding: 7px 20px;
}
.vs__dropdown-option--selected {
  background-color: #8dc540;
  color: #fff;
  position: relative;
}
.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}
[dir=rtl] .vs__dropdown-option--selected::after {
  left: 20px;
  right: unset;
}
.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #8dc540 !important;
}
.vs__clear svg {
  color: #6e6b7b;
}
.vs__selected {
  color: #fff;
}
.v-select.vs--single .vs__selected {
  color: #6e6b7b;
  transition: transform 0.2s ease;
}
[dir] .v-select.vs--single .vs__selected {
  margin-top: 5px;
}
[dir=ltr] .v-select.vs--single .vs__selected input {
  padding-left: 0;
}
[dir=rtl] .v-select.vs--single .vs__selected input {
  padding-right: 0;
}
[dir=ltr] .vs--single.vs--open .vs__selected {
  transform: translateX(5px);
}
[dir=rtl] .vs--single.vs--open .vs__selected {
  transform: translateX(-5px);
}
.vs__selected .vs__deselect {
  color: inherit;
}
.v-select:not(.vs--single) .vs__selected {
  font-size: 0.9rem;
}
[dir] .v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}
[dir=ltr] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}
[dir=rtl] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 5px 2px 2px;
}
.v-select:not(.vs--single) .vs__deselect svg {
  vertical-align: text-top;
}
[dir] .v-select:not(.vs--single) .vs__deselect svg {
  transform: scale(0.8);
}
.vs__dropdown-menu {
  top: calc(100% + 1rem);
}
[dir] .vs__dropdown-menu {
  border: none;
  border-radius: 6px;
  padding: 0;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-color: #8dc540;
  border-bottom-color: #8dc540;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0.357rem;
  border-bottom-right-radius: 0.357rem;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0.357rem;
  border-bottom-left-radius: 0.357rem;
}
.select-size-lg .vs__selected {
  font-size: 1rem !important;
}
[dir] .select-size-lg.vs--single.vs--open .vs__selected {
  margin-top: 6px;
}
.select-size-lg .vs__dropdown-toggle,
.select-size-lg .vs__selected {
  font-size: 1.25rem;
}
[dir] .select-size-lg .vs__dropdown-toggle {
  padding: 5px;
}
[dir] .select-size-lg .vs__dropdown-toggle input {
  margin-top: 0;
}
.select-size-lg .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-lg .vs__deselect svg {
  transform: scale(1) !important;
}
[dir] .select-size-sm .vs__dropdown-toggle {
  padding-bottom: 0;
  padding: 1px;
}
[dir] .select-size-sm.vs--single .vs__dropdown-toggle {
  padding: 2px;
}
.select-size-sm .vs__dropdown-toggle,
.select-size-sm .vs__selected {
  font-size: 0.9rem;
}
[dir] .select-size-sm .vs__actions {
  padding-top: 2px;
  padding-bottom: 2px;
}
.select-size-sm .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-sm .vs__search {
  margin-top: 0;
}
.select-size-sm.v-select .vs__selected {
  font-size: 0.75rem;
}
[dir] .select-size-sm.v-select .vs__selected {
  padding: 0 0.3rem;
}
[dir] .select-size-sm.v-select:not(.vs--single) .vs__selected {
  margin: 4px 5px;
}
[dir] .select-size-sm.v-select.vs--single .vs__selected {
  margin-top: 1px;
}
[dir] .select-size-sm.vs--single.vs--open .vs__selected {
  margin-top: 4px;
}
.dark-layout .vs__dropdown-toggle {
  color: #b4b7bd;
}
[dir] .dark-layout .vs__dropdown-toggle {
  background: #283046;
  border-color: #404656;
}
.dark-layout .vs__selected-options input {
  color: #b4b7bd;
}
.dark-layout .vs__selected-options input::placeholder {
  color: #676d7d;
}
.dark-layout .vs__actions svg {
  fill: #404656;
}
[dir] .dark-layout .vs__dropdown-menu {
  background: #283046;
}
.dark-layout .vs__dropdown-menu li {
  color: #b4b7bd;
}
.dark-layout .v-select:not(.vs--single) .vs__selected {
  color: #8dc540;
}
[dir] .dark-layout .v-select:not(.vs--single) .vs__selected {
  background-color: rgba(141, 197, 64, 0.12);
}
.dark-layout .v-select.vs--single .vs__selected {
  color: #b4b7bd !important;
}
.dark-layout .vs--disabled .vs__dropdown-toggle,
.dark-layout .vs--disabled .vs__clear,
.dark-layout .vs--disabled .vs__search,
.dark-layout .vs--disabled .vs__selected,
.dark-layout .vs--disabled .vs__open-indicator {
  opacity: 0.5;
}
[dir] .dark-layout .vs--disabled .vs__dropdown-toggle, [dir] .dark-layout .vs--disabled .vs__clear, [dir] .dark-layout .vs--disabled .vs__search, [dir] .dark-layout .vs--disabled .vs__selected, [dir] .dark-layout .vs--disabled .vs__open-indicator {
  background-color: #283046;
}
[dir] .filter-box {
  margin-top: 30px;
  margin-bottom: 10px;
}
[dir=ltr] .payment-desc {
  margin-right: 10px;
}
[dir=rtl] .payment-desc {
  margin-left: 10px;
}
.pay-method-row {
  display: flex;
  align-items: center;
}
.pay-method-row .pay-color-line {
  width: 3px;
  height: 10px;
}
[dir] .pay-method-row .pay-color-line {
  border-radius: 4px;
}
[dir=ltr] .pay-method-row .pay-color-line {
  margin-left: 12px;
  margin-right: 6px;
}
[dir=rtl] .pay-method-row .pay-color-line {
  margin-right: 12px;
  margin-left: 6px;
}
[dir] .pay-method-row .pay-color-line.orange {
  background: #f7984a;
}
[dir] .pay-method-row .pay-color-line.green {
  background: #00db00;
}
[dir] .pay-method-row .pay-method {
  border-radius: 4px;
  background: #ebebeb;
  padding: 4px 6px;
}
.add-pay-method {
  display: flex;
  justify-content: space-between;
}
.add-pay-method .btn {
  white-space: nowrap;
}
</style>
